export default __webpack_public_path__ + "static/media/author.ca21bb2f.webp";